




































import StorageMixin from '@/mixins/StorageMixin';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { defaultDateRangePreviousMonthToToday } from '@/utils/localCalendarDate';
import { getPreviousFullMonthRange } from '@/utils/previousMonthRange';

@Component
export default class DateRange extends StorageMixin {
  @Prop({ default: 'Диапазон дат' })
  readonly label!: string;

  @Prop({ default: false })
  readonly disabled!: boolean;

  /**
   * Если false — при открытии страницы без dateFrom/dateTo в URL не подставляются даты из localStorage,
   * и первичная подстановка диапазона по умолчанию не пишет URL и storage (до действия пользователя).
   */
  @Prop({ default: true })
  readonly restoreDatesFromLocalStorage!: boolean;

  /**
   * Если true — диапазон по умолчанию: 1-е число прошлого месяца — сегодня по локальному календарю
   * (не UTC через toISOString).
   */
  @Prop({ default: false })
  readonly localCalendarDefaultRange!: boolean;

  /** Полный предыдущий календарный месяц вместо «с 1-го прошлого месяца по сегодня». */
  @Prop({ default: false })
  readonly defaultToPreviousFullMonth!: boolean;

  @Prop({ default: false })
  readonly hasError!: boolean;

  @Prop({ default: 'Заполните поле' })
  readonly errorMessage!: string;

  /**
   * Всегда резервировать строку под сообщение (hide-details=false), даже без ошибки —
   * чтобы появление ошибки не подбрасывало соседние поля в ряду. Opt-in (default false),
   * прочие использования не затрагивает.
   */
  @Prop({ default: false })
  readonly reserveDetails!: boolean;

  /**
   * Диапазон, выставленный снаружи (форма претензии из карточки листа): поле его показывает и
   * отдаёт наверх, но в адрес и localStorage не пишет — это не выбор пользователя.
   */
  @Prop({ default: null })
  readonly presetRange!: string[] | null;

  /**
   * Поле формы, а не фильтр страницы: даты не читаются из адреса и localStorage и не пишутся туда.
   * Иначе период претензии подхватывал фильтр списка «Дата создания претензии» и менял его.
   */
  @Prop({ default: false })
  readonly detached!: boolean;

  visibleDatePicker = false

  /** Пропускает запись в storage/URL при первой гидрации диапазона по умолчанию. */
  private hydratingInitialRange = false;

  dates: string[] = ['2020-11-10', '2020-11-27']

  get dateRangeText() {
    return this.dates.map((date) => {
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    }).join(' - ');
  }

  clearFiltersHandler = () => this.setDefaultDates();

  mounted() {
    if (!this.restoreDatesFromLocalStorage) {
      this.hydratingInitialRange = true;
    }
    this.setDates();
    this.$nextTick(() => {
      this.hydratingInitialRange = false;
    });
    this.$bus.$on('clear-filters', this.clearFiltersHandler);
  }

  beforeDestroy() {
    this.$bus.$off('clear-filters', this.clearFiltersHandler);
  }

  setDates() {
    if (this.detached) {
      if (this.presetRange && this.presetRange.length === 2) {
        this.dates = [...this.presetRange];
      } else {
        this.setDefaultDates();
      }
      return;
    }
    let { dateFrom, dateTo } = this.$route.query;
    if (!dateFrom || !dateTo) {
      if (this.restoreDatesFromLocalStorage) {
        dateFrom = this.getFromStorage('date_from');
        dateTo = this.getFromStorage('date_to');
      }
    }
    if (dateFrom && dateTo) {
      this.dates = [String(dateFrom), String(dateTo)];
    } else {
      this.setDefaultDates();
    }
  }

  setDefaultDates() {
    if (this.defaultToPreviousFullMonth) {
      this.dates = getPreviousFullMonthRange();
      return;
    }
    if (this.localCalendarDefaultRange) {
      this.dates = defaultDateRangePreviousMonthToToday();
      return;
    }
    const dateNow = new Date();
    const dateAgo = new Date();
    dateAgo.setMonth(dateAgo.getMonth() - 1);
    dateAgo.setDate(1);
    this.dates = [dateAgo.toISOString().split('T')[0], dateNow.toISOString().split('T')[0]];
  }

  closeDatePickerRange(values: string[]) {
    if (values.length === 2) {
      this.visibleDatePicker = false;
    }
  }

  @Watch('presetRange')
  onPresetRange(value: string[] | null) {
    if (!value || value.length !== 2 || (this.dates[0] === value[0] && this.dates[1] === value[1])) {
      return;
    }
    this.hydratingInitialRange = true;
    this.dates = [...value];
    this.$nextTick(() => { this.hydratingInitialRange = false; });
  }

  @Watch('dates')
  datesChanged() {
    if (this.dates.length === 2) {
      if (new Date(this.dates[0]) > new Date(this.dates[1])) {
        this.dates.reverse();
      }
      if (this.hydratingInitialRange || this.detached) {
        this.$emit('datesChanged', this.dates);
        return;
      }
      const { dateFrom, dateTo } = this.$route.query;
      if (dateFrom !== this.dates[0] || dateTo !== this.dates[1]) {
        this.setToStorage('date_from', this.dates[0]);
        this.setToStorage('date_to', this.dates[1]);

        const query = { ...this.$route.query, dateFrom: this.dates[0], dateTo: this.dates[1] };
        this.$router.replace({ query });
      }

      this.$emit('datesChanged', this.dates);
    }
  }
}
